import {IBaseInstrumentItem} from 'models/resources';

export const filterInstrumentCollectionById = (collection: IBaseInstrumentItem[], id: number) =>
  collection.filter((instrument: IBaseInstrumentItem) => instrument.id !== id);
